import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { AdmindashboardComponent } from '../admindashboard/admindashboard.component';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';

@Component({
  selector: 'app-financedashboard',
  templateUrl: './financedashboard.component.html',
  styleUrls: ['./financedashboard.component.css']
})
export class FinancedashboardComponent implements OnInit {
  evaluationData : Vendordata;
  evaluationDataAny : any;
  PurchaseOrderData:any;
  NewVendors:any;
  MessageCount:any;
  constructor(private router:Router, private  evaluationService:EvaluationService,  private adminDashboardService:AdmindashboardService, userservice:UserService, private dataSharinService:DataSharingService,) { }

  ngOnInit() {
    this.adminDashboardService.getPurchaseOrders().subscribe(
      (data)=>{
        this.PurchaseOrderData=data;
        console.log(this.PurchaseOrderData);
      }
    )
    this.adminDashboardService.getNewVendors().subscribe(
      (data)=>{
        this.NewVendors=data;
        console.log(this.NewVendors);
      }
    )
    this.adminDashboardService.getMessageCount().subscribe(
      (data)=>{
        this.MessageCount=data;
        console.log("Message count"+this.MessageCount);
      }
    )

  
      this.evaluationService.getVendorsForEvaluation().subscribe(
        (data) => {
          this.evaluationDataAny = data;
          this.evaluationData = this.evaluationDataAny;
          console.log(this.evaluationData);
        }
      )
    
    }
  
  

}
